export class Global {
  public static readonly VENDEDOR_ATIVO = 'bd497249-132e-4a60-98e4-5b1dcc5b69b1';
  public static readonly ORGANIZACAO_ATIVA = 'df00f5ae-77b3-4fd0-8a58-93a112827be8';
}
